export default "__VITE_ASSET__DawTp6r6__"